import React from "react";

import MainTemplate from "@/components/Templates/MainTemplate";
import HeroSection from "./HeroSection";
import BenefitsSection from "./BenefitsSection";
// import PartnersSection from "./PartnersSection";
import FAQSection from "./FAQSection";
import ActionBannerSection from "./ActionBannerSection";

const LandingPage = () => (
  <MainTemplate hideHeader>
    <HeroSection />
    <BenefitsSection />
    <ActionBannerSection />
    {/* <PartnersSection /> */}
    <FAQSection />
  </MainTemplate>
);

export default LandingPage;
